(ns app.domain.ordered.util)

(defn- order-value [entity-or-order]
  (if (integer? entity-or-order)
    entity-or-order
    (:ordered/order entity-or-order)))

(defn order-fn
  "Returns a function that remaps ordering indexes for a reorder request.
   It moves the source entity to the target position and shifts any indexes
   between them to preserve a dense, sequential ordering."
  [from to]
  (let [from-ix (order-value from)
        to-ix   (order-value to)]
    (when-not (and (integer? from-ix) (integer? to-ix))
      (throw (ex-info "Invalid ordering request" {:from-ix from-ix :to-ix to-ix})))
    (fn [entity-or-order]
      (let [ix (order-value entity-or-order)]
        (when-not (integer? ix)
          (throw (ex-info "Invalid ordering request" {:from-ix from-ix :to-ix to-ix :ix ix})))
        (cond
          (= ix from-ix) to-ix
          (and (> ix from-ix) (<= ix to-ix)) (dec ix)
          (and (>= ix to-ix) (< ix from-ix)) (inc ix)
          :else ix)))))

(defn ordering-map [order-fn entities]
  (->> (sort-by order-fn entities)
       (map-indexed (fn [ix entity] [(:db/id entity) ix]))
       (into {})))
